<template>
  <div class="passengers">
    <h5 class="passengers__title">Lista de Bagagens</h5>

    <div class="passengers__tips">
				<span>
					- Utilize está lista apenas para conferência de passageiros.
				</span>
      <br>
      <span>
					- Os registros conferidos são apenas visual.
				</span>
    </div>


    <div v-show="filterPassengerByLugages().length == 0 && passengerStatus === false">
      <span class="text-bold">Por hora esse veículo não possui passageiros.</span>
    </div>

    <q-list>
      <q-slide-item
        :key="passenger.ticket_id"
        class="passengers__ticket card"
        left-color="cancel"
        right-color="confirm"
        v-for="passenger in filterPassengerByLugages()"
      >
        <q-item class="ticket__container">
          <q-item-section class="ticket__info q-pa-sm">
						<span class="info--highlight text-capitalize">
              {{ passenger.name.toLowerCase() }}
            </span>

            <div class="text-uppercase">
							<span v-show="passenger.document_type !== ''">
                {{ passenger.document_type }}:&nbsp;
              </span>
              <span v-show="passenger.document_type === ''">
                Outros:
              </span>
              <span class="info--highlight">
                {{ passenger.document_number }}
              </span>
            </div>

            <div>
              Poltrona: <span class="info--highlight">{{ passenger.seat }}</span>
            </div>
            <div>
              Tipo de bilhete: <span class="info--highlight">{{ passenger.description }}</span>
            </div>
            <div>
              Destino: <span class="info--highlight">{{ passenger.landing }}</span>
            </div>
            
            <div class="q-mt-sm q-mb-sm" v-if="passenger.luggages"><q-separator /></div>
            <div class="flex" v-if="passenger.luggages">
            <i class="ri-suitcase-3-line" style="color: #004923;"></i>
              Bagagens: <span class="q-ml-sm info--highlight" v-for="(luggage, index) in passenger.luggages" :key="index+'luggages'">
                Nº {{ luggage.number }},
              </span>
            </div>

          </q-item-section>

          <q-item-section>
            <q-checkbox :val="passenger.seat" v-model="status" color="teal" />
          </q-item-section>
        </q-item>
      </q-slide-item>
    </q-list>
  </div>
</template>

<script>
import { SELECTED_SCHEDULE } from "../../variables";

import {
  clearDate,
  getHost,
  getSessionStorage
} from "../../functions";

import { mutations, store } from "../../store";

  export default {
    name: 'Passengers',

    computed: {
      passengersListOld: {
        get() {
          return store.passengersList
        },
        set(value) {
          mutations.setPassengersList(value)
        },
      },
    },

    data() {
      return {
        status: [],
        passengerStatus: 'false',
        passengersList: [],
        chedule: {},
      }
  },

  created () {
    this.sections = getSessionStorage("sections");
    this.schedule = getSessionStorage(SELECTED_SCHEDULE);
    this.getPassengers();
  },

  methods: {
    getPassengers() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then(response => {
         this.passengersList = response.data;
      });
    },
      howManyPassengerStatus(status) {
        return this.passengersList.filter(v => v.boarding_status === status).length
      },

    filterPassengerByLugages () {
      let list = []
        for (const passenger of this.passengersList) {
          if (passenger.luggages) {
            list.push(passenger)
          }
        }
        return list
      },
    },
  }
</script>

<style lang="scss" scoped>

.bg-cancel {
  background-color: #B30C00;
}

.bg-confirm {
  background-color: #20C600;
}


.passengers {
	display: grid;

	width: 90%;
	margin: auto;
}

.passengers__title {
	font-size: 0.9rem;
	font-weight: 600;
	text-transform: uppercase;
	color: #000000;

	margin: 0;
}

.passengers__tips {
	font-size: 0.7rem;
	color: #7A8583;

	margin-bottom: 10px;
}

.passengers__ticket {
	background-color: #FFFFFF;

  margin-bottom: 5px;
}

.passengers--boarded {
  background-color: #F2FDF2;
  border: #1DC800 solid 1px;
}

.ticket__container {
	display: grid;
	grid-template-columns: 1fr max-content;
  align-items: center;

  height: 100%;
	width: 90%;
	margin: auto;
	padding: 4px 0;
}

.ticket__info {
	color: #7A8583;
	font-size: 14px;
	line-height: normal;
}

.ticket__icon {
	place-self: end;

	color: #7A8583;
	font-size: 30px;
}

.ticket__icon--boarded {
  color: #20C600;
}

.ticket__icon--effect {
  animation-name: slide;
  animation-delay: 2s;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;

  @keyframes slide {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-20px);
    }
  }
}

.info--highlight {
	font-weight: 600;
	color: #040006;
}


/* Quasar reset */

.q-slide-item__content {
  height: 100%;
}
</style>
